import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediStyles from 'assets/styles/default.scss';

export const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        display: 'flex',
        flexDirection: 'row',
        marginTop: 0,
        marginBottom: 0,
      },
      textField: {
        width: '100%'
      },
      buttonAdicionar: {
        width: '100%',
        [theme.breakpoints.up('sm')]: {
          marginTop: '10px'
        }
      },
      textItens: {
        marginBottom: '10px'
      },
      textSelectItens: {
        marginBottom: '10px',
        width: '100% !important'
      },
      dropdownIcon: {
        fontSize: 16,
        color: sicrediStyles.primarySicredi,
        position: 'absolute',
        right: 0,
        top: '50%',
        transform: 'translateY(-50%)'
      },
      itensList: {
        height: '57px',
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
        fontFamily: '"Exo 2"',
        fontSize: '18px',
        marginBottom: '10px',
        whiteSpace: 'nowrap', 
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      itensContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        borderTop: '1px solid #CDD3CD',
        marginTop: '30px',
      },
      itemText: {
        
      },
      itensContainerTitle: {
        fontFamily: 'Nunito',
        textAlign: 'center',
        color: '#323C32',
        marginTop: '10px'
      },
      confirmButtom: {
        marginTop: '50px',
        textAlign: 'right'
      },
      deleteButton: {
        float: 'left',
        paddingRight: '20px'
      },
      abstencao: {
        marginLeft: '60px'
      },
      text: {
        whiteSpace: 'nowrap', 
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }
    }),
  {
    name: 'CadastroPautaModal',
  }
);
